import { render } from "./QuoteBlock.vue?vue&type=template&id=7ee4bb50"
import script from "./QuoteBlock.vue?vue&type=script&lang=js"
export * from "./QuoteBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__